/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AddToast from "../../../state/actions/AddToast";
import {
  userHasAnsweredRecently,
  setUserHasAnsweredRecentlyKey,
} from "../../../common/helpers/localStorageActions";
import Modal from "../../../components/atoms/Modal";
import {
  getVariantResult,
  getApiUrl,
} from "../../../state/selectors/general.selectors";
import { httpRequest } from "../../../services/http";

const UserQuestions = ({ variantResult, apiUrl }) => {
  const [questions, setQuestions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);

  useEffect(() => {
    if (!variantResult || userHasAnsweredRecently()) {
      return;
    }

    if (variantResult.query_log_id) {
      const questionsReceived = [];
      if (
        variantResult.user_multiple_choice_questions &&
        variantResult.user_multiple_choice_questions.length > 0
      ) {
        const questionsArray = variantResult.user_multiple_choice_questions[0];
        const answers = questionsArray.slice(1, questionsArray.length - 1);
        const id = questionsArray[questionsArray.length - 1];
        questionsReceived.push({ question: questionsArray[0], answers, id });
        setQuestions(questionsReceived);
        setModalOpen(true);
      } else if (
        variantResult.user_free_format_question &&
        variantResult.user_free_format_question.length > 0
      ) {
        const freeQuestion = variantResult.user_free_format_question[0];
        const [question, id] = freeQuestion;
        questionsReceived.push({ question, id });
        setQuestions(questionsReceived);
        setModalOpen(true);
      }
    }
  }, [variantResult]);

  useEffect(() => {
    setSubmitDisabled(!questions || !questions.length || !questions[0].answer);
  }, [questions]);

  const setAnswer = (userAnswer) => {
    const questionsCopy = [...questions];
    questionsCopy[0].answer = userAnswer;
    setQuestions(questionsCopy);
  };

  const sendAnswers = () => {
    const url = `${apiUrl}/user_answers/${variantResult.query_log_id}`;
    const data = [
      {
        id: questions[0].id,
        answer: questions[0].answer,
      },
    ];

    httpRequest
      .post(url, { questions: data })
      .then(() => {
        AddToast("Answers submitted succesfully", "success");
        setUserHasAnsweredRecentlyKey();
        setModalOpen(false);
      })
      .catch((err) => {
        AddToast("Error submitting answers");
        console.error("While submitting answers:", err);
        setModalOpen(false);
      });
  };

  if (!questions || questions.length === 0) return null;

  if (questions[0]) {
    const q = questions[0];
    return (
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        ContentRender={() => (
          <div className="tw-p-6" style={{ width: "500px" }}>
            <h4>
              <b>Question</b>
            </h4>
            <div className="tw-text-md">
              <div className="tw-mb-4">
                <p>{q.question}</p>
                {q.answers && q.answers.length > 0 ? (
                  q.answers.map((ans, j) => (
                    <label
                      key={`answer-${j}`}
                      className="form-check-label"
                      onClick={() => setAnswer(ans)}
                    >
                      <span className="tw-mr-5" />
                      <input
                        className="form-check-input"
                        type="radio"
                        value="false"
                        checked={q.answer === ans}
                      />
                      <span className="tw-mr-2">{ans}</span>
                    </label>
                  ))
                ) : (
                  <textarea
                    className="tw-w-full tw-border tw-p-2 focus:tw-outline-none focus:tw-ring focus:tw-border-blue-300 tw-h-40"
                    type="text"
                    id="textInput"
                    name="textInput"
                    placeholder="Please provide your answer"
                    onChange={(e) => {
                      const ans = e.target.value;
                      setAnswer(ans);
                    }}
                  />
                )}
              </div>
            </div>
            <div className="tw-text-right">
              <button
                type="button"
                disabled={submitDisabled}
                className="btn btn-success"
                onClick={() => sendAnswers()}
              >
                Submit
              </button>
            </div>
          </div>
        )}
      />
    );
  }
  return null;
};

const mapStateToProps = (state) => ({
  variantResult: getVariantResult(state),
  apiUrl: getApiUrl(state),
});

UserQuestions.propTypes = {
  apiUrl: PropTypes.string,
  variantResult: PropTypes.shape({}),
};

UserQuestions.defaultProps = {
  apiUrl: "",
  variantResult: null,
};

export default connect(mapStateToProps)(UserQuestions);
